import { type DeactivateUserCommandResult, putUserDeactivate } from "Api/Api";
import type { NavigateFunction } from "Navigation/useNavigate";
import { resetUser } from "State/Auth/AuthReducer";
import { appUrl } from "Utils/UrlUtils";
import { put, takeLatest } from "redux-saga/effects";
import { call } from "typed-redux-saga";
import { createAsyncAction } from "typesafe-actions";
import { getType } from "typesafe-actions";
import { toast } from "sonner";
import { Resources, getResourcePath } from "Translations/Resources";
import i18next from "i18next";

export const deactivateUserAsync = createAsyncAction(
  "@user/DEACTIVATE_REQUEST",
  "@user/DEACTIVATE_SUCCESS",
  "@user/DEACTIVATE_FAILURE",
)<{ navigate: NavigateFunction }, DeactivateUserCommandResult, Error>();

function* deactivateUser(
  action: ReturnType<typeof deactivateUserAsync.request>,
): Generator {
  try {
    const response = yield* call(putUserDeactivate);
    if (response.status === 200) {
      yield put(deactivateUserAsync.success(response.json));
      toast.success(
        i18next.t(
          getResourcePath(
            Resources.Components.Account.DeactivateUser.SuccessMessage,
          ),
        ),
      );
      yield put(
        resetUser({
          onAfterReset: () =>
            action.payload.navigate(appUrl("sign-in"), { replace: true }),
        }),
      );
    } else {
      yield put(
        deactivateUserAsync.failure(
          new Error(`Error in action ${action.type}`, {
            cause: response.status,
          }),
        ),
      );
    }
  } catch (err) {
    yield put(deactivateUserAsync.failure(err as Error));
  }
}
export function* deactivateUserSaga() {
  yield takeLatest(getType(deactivateUserAsync.request), deactivateUser);
}
